import React from 'react';
import { XIcon } from 'lucide-react';
import { dolores } from '../data/content';
export function PainSection() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="dolor" data-id="element-121" data-mp="38wlvkxicj0ju">
      <div className="mx-auto max-w-readable px-5 sm:px-8" data-id="element-122" data-mp="2uyxappoa3tes">
        <h2 id="dolor" className="max-w-3xl font-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-123" data-mp="2yzqvia6fcs3g">
          ¿Cuántos domingos más vas a terminar sintiéndote igual?
        </h2>

        <div className="mt-8 grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14" data-id="element-124" data-mp="2q042ocrrgum0">
          <div className="max-w-xl space-y-4 text-[17px] leading-relaxed text-ink/75" data-id="element-125" data-mp="2baodv2bsiz8y">
            <p data-id="element-126" data-mp="2g8zovgdtnfsr">
              Sos inteligente. Sabés lo que necesitás cambiar. Pero nadie te dio
              el mapa completo para tu realidad concreta: adulto en Argentina,
              con presión económica, agenda apretada y un entorno que cambia
              cada semana.
            </p>
            <p className="border-l-2 border-flame pl-4 font-display text-lg font-bold text-ink" data-id="element-127" data-mp="3rmr3nw73il0y">
              No es falta de voluntad. Es falta de un sistema diseñado para tu
              contexto real.
            </p>
          </div>

          <ul className="grid gap-px overflow-hidden rounded-2xl bg-ink/10 sm:grid-cols-2" data-id="element-128" data-mp="5ehqqzedc9ry">
            {dolores.map(dolor => <li key={dolor} className="flex items-start gap-3 bg-cream p-5 text-[15px] leading-snug text-ink/80" data-id="element-129" data-mp="emwqmzar42o">
                <XIcon className="mt-1 h-4 w-4 shrink-0 text-flame" aria-hidden="true" data-id="element-130" data-mp="33yrciv5vgslu" />
                {dolor}
              </li>)}
          </ul>
        </div>

        <p className="mt-12 font-display text-2xl font-extrabold text-ink sm:text-3xl" data-id="element-131" data-mp="3dub79e8p9l90">
          ¿Y si este fuera el último domingo que terminás sintiéndote así?
        </p>
      </div>
    </section>;
}